/* eslint-disable prefer-promise-reject-errors */
// src/services/indexeddbService.js

const DB_NAME = "meuAppDB";
const DB_VERSION = 1;
const STORE_NAME = "relatorios";

function openIndexedDbInstance() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };

    request.onsuccess = (event) => {
      resolve(event.target.result);
    };

    request.onerror = () => {
      reject("Erro ao abrir o IndexedDB");
    };
  });
}

export async function saveReports(id, dados) {
  const db = await openIndexedDbInstance();

  return new Promise((resolve, reject) => {
    const transacao = db.transaction(STORE_NAME, "readwrite");
    const store = transacao.objectStore(STORE_NAME);

    store.put({ id, dados });

    transacao.oncomplete = () => {
      db.close();
      resolve();
    };

    transacao.onerror = () => {
      reject("Erro ao salvar relatório");
    };
  });
}

export async function loadReports(id) {
  const db = await openIndexedDbInstance();

  return new Promise((resolve, reject) => {
    const transacao = db.transaction(STORE_NAME, "readonly");
    const store = transacao.objectStore(STORE_NAME);

    const request = store.get(id);

    request.onsuccess = () => {
      db.close();
      resolve(request.result?.dados || null);
    };

    request.onerror = () => {
      reject("Erro ao carregar relatório");
    };
  });
}

export async function deleteReports(id) {
  const db = await openIndexedDbInstance();

  return new Promise((resolve, reject) => {
    const transacao = db.transaction(STORE_NAME, "readwrite");
    const store = transacao.objectStore(STORE_NAME);

    store.delete(id);

    transacao.oncomplete = () => {
      db.close();
      resolve();
    };

    transacao.onerror = () => {
      reject("Erro ao remover relatório");
    };
  });
}
